import styled from "styled-components";

export const CompleteIcon = styled.img`
  height: 45px;
  width: 45px;
  object-fit: contain;
  padding: 0 2px;
  margin-right: 4px;
`;
